export const SUGGESTED_JOBS_URL = '/candidate/suggested-jobs';

/**
 * List of keys from geoAC autocomplete location results that must have
 * data in order for the form submission to be valid.
 */
export const REQUIRED_FIELDS = ['city', 'admin1_code', 'postal_code', 'cc'];

/**
 * Mapping of localization data. To add a new country, add info for that country
 * to all top-level keys below, *and* also update Yup validation in
 * PartnerRequiredFields.jsx. 'other' is treated as a special case in
 * the form.
 */
export const LOCALE_DATA = {
  countries: ['us', 'ca', 'other'], // keys for below
  zip_code_label: {
    us: 'ZIP code',
    ca: 'Postal code',
    other: 'ZIP / Postal code',
  },
  form_label: {
    us: 'United States',
    ca: 'Canada',
    other: 'Other',
  },
  form_value: {
    us: 'us',
    ca: 'ca',
    other: 'other',
  },
  geo_ac_filter: {
    us: 'usa',
    ca: 'ca',
    other: '',
  },
};
